import { Company } from "src/models/company";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CompanyEntityModel = createEntityModel<Company>();
